export default __webpack_public_path__ + "static/media/template_create.0bcccd40.png";